/*--------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * See License.txt in the project root for license information.
 *--------------------------------------------------------------*/

export enum CheckoutStorageKey {
    BillingAddress = 'BillingAddress',
    GiftCard = 'GiftCard',
    LoyaltyCardNumber = 'LoyaltyCardNumber',
    LoyaltyAmount = 'LoyaltyAmount',
    TermsAndCondition = 'TermsAndCondition',
    CheckoutGenericData = 'Checkout-Generic-Data',
    PaymentTenderType = 'PaymentTenderType'
}
